import { render, staticRenderFns } from "./InternalInformationList.vue?vue&type=template&id=01950e8c&scoped=true"
import script from "./InternalInformationList.vue?vue&type=script&lang=ts"
export * from "./InternalInformationList.vue?vue&type=script&lang=ts"
import style0 from "./InternalInformationList.vue?vue&type=style&index=0&id=01950e8c&prod&lang=css"
import style1 from "./InternalInformationList.vue?vue&type=style&index=1&id=01950e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01950e8c",
  null
  
)

export default component.exports